let notified = false

export function notifyRenderReady() {
  if (notified || typeof document === 'undefined') return
  notified = true
  const dispatch = () => document.dispatchEvent(new Event('render-event'))
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => requestAnimationFrame(dispatch))
    return
  }
  setTimeout(dispatch, 0)
}

export function resetRenderReady() {
  notified = false
}
